import { useTranslation } from "react-i18next";
import { useFetch } from "../../../../hooks/api";
import { Col, Table } from "react-bootstrap";
import moment from "moment";
import Loading from "../../../core/blocks/Loading";
import { formatCurrency } from "../../../../utils/formatNumber";
import { useAppSelector } from "../../../../redux/hooks";

const LineItemBiddingProgramLog = ({ lineItemId }) => {
  const { t } = useTranslation(["programs"]);
  const { marketPlace } = useAppSelector((state) => state.marketPlace);

  const { data, isLoading } = useFetch(
    ["program_line_item_bidding_logs", lineItemId],
    `/programlogs/dsp_line_items/`,
    {
      line_item: lineItemId,
    },
    { enabled: !!lineItemId, select: (data) => data?.data?.results ?? [] },
  );
  return (
    <Col>
      {isLoading && <Loading height={"300px"} fullPage={false} />}
      {!isLoading && (
        <Table striped bordered>
          <thead>
            <tr>
              <th>{t(($) => $.programs.log.Time)}</th>
              <th>{t(($) => $.programs.log.Program)}</th>
              <th>{t(($) => $.programs.log.Action)}</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((log, i) => {
              return (
                <tr key={i}>
                  <td>{moment(log.ts).format("YYYY-MM-DD HH:mm:ss")}</td>
                  <td>
                    {log?.program?.name} ({log?.program?.id})
                  </td>
                  <td>
                    {log?.meta[1]?.function !== undefined ?
                      <div>
                        <span className="fw-bold">{log?.meta[1]?.function}</span>
                        :&nbsp;
                        <span className="fw-light">
                          {t(($) => $.programs.log["New: {amount}"], {
                            amount: formatCurrency(log?.meta[1]?.next_bid, {
                              marketPlace: marketPlace,
                            }),
                          })}
                        </span>
                        &nbsp; - &nbsp;
                        <span className="fw-light">
                          {t(($) => $.programs.log["Prev: {amount}"], {
                            amount: formatCurrency(log?.meta[1]?.current_bid, {
                              marketPlace: marketPlace,
                            }),
                          })}
                        </span>
                      </div>
                    : t(($) => $.programs.log["N/A"])}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      )}
    </Col>
  );
};

export default LineItemBiddingProgramLog;
